import React, { useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import { SCREEN_SIZES } from "utils/constants";
import "react-sliding-pane/dist/react-sliding-pane.css";
import CartHeader from "./header";
import CartBody from "./body";
import CartFooter from "./footer";
import { useMediaQuery } from "react-responsive";
import { useSettings, useCart, useCustomer } from "hooks/useStore";
import { trackViewCart } from "analytics";
import CartSummary from "./summary";
import clsx from "clsx/lite";
import Link from "components/link";

const Cart = ({ sliceContext, previewData }) => {
	const { announcementBar, footerImage, upsellProducts, protectionVariants, warrantyProducts } = previewData || sliceContext;
	const { isCartOpen, toggleCart } = useSettings(["isCartOpen", "toggleCart"]);
	const { items, totalPrice, totalQuantity, shippingProtection, initShippingProtection } =
		useCart(["items", "totalPrice", "totalQuantity", "shippingProtection", "initShippingProtection"]);

	const customer = useCustomer();

	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.sm });

	useEffect(() => {
		if (protectionVariants && !shippingProtection.variants?.length) {
			initShippingProtection(protectionVariants, totalPrice);
		}
	}, [protectionVariants]);

	useEffect(() => {
		if (isCartOpen) {
			trackViewCart({ items, totalPrice }, customer);
		}

		if (document.body.classList.contains("ReactModal__Body--open") && !isCartOpen)
			document.body.classList.remove("ReactModal__Body--open");

	}, [isCartOpen]);

	return (
		<SlidingPane
			from={isMobile ? "bottom" : "right"}
			width={isMobile ? "100%" : "500px"}
			className={
				clsx("mt-auto overflow-hidden z-70",
					isMobile && "!mt-0 !h-full"
				)}
			overlayClassName="flex items-center z-70"
			isOpen={isCartOpen}
			hideHeader
			shouldCloseOnEsc
			onRequestClose={toggleCart}
		>
			<div className="min-h-full flex flex-col overflow-hidden h-full">
				<CartHeader announcementBar={announcementBar} />
				{totalQuantity > 0 &&
					<div className="pt-4 px-5 border-b minimal-cart-summary">
						<Link to="/cart" onClick={toggleCart} className="btn-secondary w-full text-center mb-2 py-4 review-cart-btn">
							Review Cart
						</Link>
						<CartSummary defaultArrowDown />
					</div>}
				<CartBody upsellProducts={upsellProducts} warrantyProducts={warrantyProducts} />
				<CartFooter image={footerImage} />
			</div>
		</SlidingPane>
	);
};

export default Cart;